module.exports = __webpack_public_path__ + "img/loading.2c0c5093.gif";